import CheckCircleOutlineIcon from 'mdi-react/CheckCircleOutlineIcon'
import ClockOutlineIcon from 'mdi-react/ClockOutlineIcon'
import CloseOctagonOutlineIcon from 'mdi-react/CloseOctagonOutlineIcon'
import FileDocumentOutlineIcon from 'mdi-react/FileDocumentOutlineIcon'

import { useAppContext } from '@/App.context'
import { CREDIT_CHECK_STATUS } from '@/util/credit-check'

import './credit-check-status-icon.scss'
// @ts-ignore
const getIcon = status => {
  switch (status) {
    case CREDIT_CHECK_STATUS.APPROVED:
      return CheckCircleOutlineIcon
    case CREDIT_CHECK_STATUS.REJECTED:
      return CloseOctagonOutlineIcon
    case CREDIT_CHECK_STATUS.DOC_REQUIRED:
      return FileDocumentOutlineIcon
    case CREDIT_CHECK_STATUS.PENDING:
    default:
      return ClockOutlineIcon
  }
}

const CreditCheckStatusIcon = ({ status }: any) => {
  const { whiteLabel } = useAppContext()

  if (!status) return null

  const Icon = getIcon(status)

  return <Icon className={`credit-check-status-icon ${status.toLowerCase()} wl-${whiteLabel}`} />
}

export default CreditCheckStatusIcon
